var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"col-xs-12 col-md-1 margin-top-3",on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('div',{staticClass:"row arrow-back-container"},[_c('sdx-icon',{attrs:{"icon-name":"icon-arrow-left","size":"3"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }